import React from "react";
import ConfettiExplosion from "react-confetti-explosion";

const Conffeti = () => {
  return <ConfettiExplosion />;
};

export default React.memo(Conffeti);
